import type { MenuItem } from '../../../shared/config/menuVoteData';
import { MENU_ITEMS } from '../../../shared/config/menuVoteData';
import type { RankEntry } from '../../../shared/config/menuResultData';
import { RANKING } from '../../../shared/config/menuResultData';

/** 2·3·4위 고정 % / 득표수 / 아이콘 (이름·썸네일만 교체) */
const RANK_SLOTS = RANKING.map(({ ratePercent, voteCount, icon }) => ({
  ratePercent,
  voteCount,
  icon,
}));

/** 슬롯 배정 순서 — 캐러셀 노출 순 */
const MENU_SLOT_ORDER: Record<string, number> = {
  'menu-woorong': 0,
  'menu-sogogi': 1,
  'menu-pyogo': 2,
  'menu-all': 3,
};

/** 1위(사용자 선택) 제외 → 2·3·4위 이름·이미지만 교체, %·득표수는 순위 고정 */
export function buildRankingForWinner(winner: MenuItem): RankEntry[] {
  const others = MENU_ITEMS.filter(
    (item) => !item.isPlaceholder && item.id !== winner.id && item.name !== winner.name,
  ).sort((a, b) => (MENU_SLOT_ORDER[a.id] ?? 99) - (MENU_SLOT_ORDER[b.id] ?? 99));

  return others.slice(0, RANK_SLOTS.length).map((item, index) => {
    const slot = RANK_SLOTS[index];
    return {
      id: `rank-${item.id}`,
      name: item.name,
      ratePercent: slot.ratePercent,
      voteCount: slot.voteCount,
      thumb: item.image,
      icon: slot.icon,
    };
  });
}
